import { render, staticRenderFns } from "./BrandGroup.vue?vue&type=template&id=284903e1&"
import script from "./BrandGroup.vue?vue&type=script&lang=js&"
export * from "./BrandGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports